module.exports = __webpack_public_path__ + "img/invoice-de-female-banner-bb.ffe80bf1.png";